import { render, staticRenderFns } from "./DHME.M.ModuleDashboard.vue?vue&type=template&id=79ee822e&scoped=true"
import script from "./DHME.M.ModuleDashboard.vue?vue&type=script&lang=js"
export * from "./DHME.M.ModuleDashboard.vue?vue&type=script&lang=js"
import style0 from "./DHME.M.ModuleDashboard.vue?vue&type=style&index=0&id=79ee822e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ee822e",
  null
  
)

export default component.exports